import React, { useState } from "react";
import { Layout, Select } from "antd";

import ResultsListContainer from "./ResultsList/container";

import SideBar from "../../../components/SideBar/container";
const { Header, Content, Footer } = Layout;
const { Option } = Select;

function ResultCollection() {
  const [selected, setSelected] = useState("360");

  function handleChange(value) {
    setSelected(value);
  }

  return (
    <Layout style={{ height: "100vh" }}>
      <SideBar />
      <Layout>
        <Header
          style={{
            textAlign: "left",
            background: "#fff",
            padding: "0 24px",
            borderBottom: "1px solid"
          }}
        >
          <h1>Surveys</h1>
          <p style={{ float: "right", marginTop: "-50px" }}>
            Viste evalueringer:{" "}
            <Select defaultValue="360" onChange={handleChange}>
              <Option value="360">Leadership Evaluation</Option>
              <Option value="profile">Transactional Analysis</Option>
            </Select>
          </p>
        </Header>
        <Content style={{ backgroundColor: "#fff" }}>
          <div
            style={{ padding: "40px 24px", background: "#fff", minHeight: 360 }}
          >
            <ResultsListContainer selected={selected} />
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>iLead © 2018</Footer>
      </Layout>
    </Layout>
  );
}

export default ResultCollection;



// WEBPACK FOOTER //
// ./src/pages/Admin/ResultCollection/index.js